import React from 'react';
import { Modal } from 'react-bootstrap';

function VideoModal({ show, onHide, videoHtml }) {
    if (!videoHtml) return null;

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Body className="video-modal-body">
                <div dangerouslySetInnerHTML={{ __html: videoHtml }} />
            </Modal.Body>
        </Modal>
    );
}

export default VideoModal;
